import React, { useState, useEffect } from 'react';
import { useCountry } from '../../context/CountryContext';
import '../../styles/components/CountrySelector.css';

const CountrySelector: React.FC = () => {
  const { selectedCountry, setSelectedCountry, availableCountries } = useCountry();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const selectedCountryData = availableCountries.find(country => country.code === selectedCountry);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleCountrySelect = (countryCode: string) => {
    setSelectedCountry(countryCode);
    setDropdownOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (dropdownOpen && !target.closest('.country-selector')) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <div className="country-selector">
      <button 
        className="country-selector-button" 
        onClick={toggleDropdown}
        aria-label="Select country"
      >
        <span className="country-selector-text">{selectedCountryData?.name || 'Select Country'}</span>
        <i className={`bi bi-chevron-down dropdown-chevron ${dropdownOpen ? 'rotated' : ''}`}></i>
      </button>
      
      {dropdownOpen && (
        <div className="country-selector-dropdown">
          {availableCountries.map(country => (
            <button
              key={country.code}
              className={`country-option ${country.code === selectedCountry ? 'selected' : ''}`}
              onClick={() => handleCountrySelect(country.code)}
            >
              {country.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySelector;
